import { Layout, OrderLog } from '@/views/order-log';

export default {
    path: '/order-log',
    component: Layout,
    children: [
        { path: '', component: OrderLog },
    ]
};
